module.exports = __webpack_public_path__ + "img/kefu_icon.80771669.png";